import type { CycleChapter, SettingKey } from "../../api/gen/model";
import { isOneOf } from "../../search";

// Plain sets, not the API's schemas: the routes read the address before any page is loaded.
const settingKeys: Record<SettingKey, true> = {
  grid_days: true,
  grid_hours: true,
  story_days: true,
  carousel_share: true,
  hashtags: true,
};

const chapters: Record<CycleChapter, true> = {
  works_in_progress: true,
  delivery: true,
  one_year_after: true,
  other: true,
};

/** The chapter a resumed project's next cycle tells, carried in the address from the project to its cycle's setup. */
export function validateChapterSearch(search: Record<string, unknown>): { chapter?: CycleChapter } {
  const chapter = search["chapter"];
  return isOneOf(chapters, chapter) ? { chapter } : {};
}

/** What a cycle's setup carries in its address: the chapter of a resumed project, and the setting of the performance
 * agent the archi chose to apply to it from their results. */
export function validateCycleSearch(search: Record<string, unknown>): { chapter?: CycleChapter; apply?: SettingKey } {
  const apply = search["apply"];
  return { ...validateChapterSearch(search), ...(isOneOf(settingKeys, apply) ? { apply } : {}) };
}
